import { registerTourPage } from '@/composables/tour/tourRegistry';
import { step } from '@/composables/tour/stepHelpers';

registerTourPage('admin-daily-attendance', {
  key: 'admin-daily-attendance',
  label: 'Daily Attendance',
  getSteps: () => [
    step({
      target: '#tour-attendance-metrics',
      title: 'Today at a Glance',
      content:
        'Live counters for the class you\'re marking — how many students are present, absent, or late, plus the total roll. They update as you mark each student.',
      placement: 'bottom',
    }),
    step({
      target: '#tour-attendance-controls',
      title: 'Pick a Class & Date',
      content:
        'Choose the classroom, the date, and (if your school marks per session) Morning or Afternoon. The student list and any saved marks load below. "History" opens past attendance for the same class.',
      placement: 'bottom',
    }),
  ],
});
